import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=34e07e54&"
import script from "./pagination.js?vue&type=script&lang=js&"
export * from "./pagination.js?vue&type=script&lang=js&"
import style0 from "./pagination.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports